<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import VueBootstrapAutocomplete from '@vue-bootstrap-components/vue-bootstrap-autocomplete'
import { toast, variants } from "@/helpers/toaster";
import ConfirmationModal from '../../../components/confirmationModal.vue';

export default {
  page: {
    title: "Porudžbenice",
  },
  components: {PageHeader, Layout, VueBootstrapAutocomplete, ConfirmationModal},
  props: {
  },
  data() {
    return {
      title: 'Porudžbenice',
      search: '',
      statuses: [
        { key: 'ALLOW_ORDERING', value: 'Aktivan' },
        { key: 'DISALLOW_ORDERING', value: 'Neaktivan' },
        { key: 'SOFT_ORDERED', value: 'Poslato' }
      ],
      status: '',
      initialFields: [
        {key: 'id', label: 'Id', sortable: false},
        {key: 'sifra', label: 'Šifra', sortable: false},
        {key: 'pak', label: 'Pak', sortable: false},
        {key: 'jm', label: 'JM', sortable: false},
        {key: 'naziv_artikla2', label: 'Naziv Artikla', sortable: false},
        {key: 'cena', label: 'Cena', sortable: false},
        {key: 'rabat', label: 'Rabat', sortable: false},
        {key: 'cena_sa_rabatom', label: 'Cena sa Rabatom', sortable: false},
      ],
      fields: [
        {key: 'id', label: 'Id', sortable: false},
        {key: 'sifra', label: 'Šifra', sortable: false},
        {key: 'pak', label: 'Pak', sortable: false},
        {key: 'jm', label: 'JM', sortable: false},
        {key: 'naziv_artikla2', label: 'Naziv Artikla', sortable: false},
        {key: 'cena', label: 'Cena', sortable: false},
        {key: 'rabat', label: 'Rabat', sortable: false},
        {key: 'cena_sa_rabatom', label: 'Cena sa Rabatom', sortable: false},
      ],
      orderFormItems: [],
      admins: [],
      selectedAdmin: null,
      groups: [],
      selectedGroup: null,
      showOrdered: true,
      adminQuery: '',
      groupsQuery: '',
      deadline: {
        value: '',
        error: false,
      },
    }
  },
  watch: {
    showOrdered(v) {
      this.search = '';
    },
    adminQuery(v) {
      if (!this.admins.find(e => e.company_name === v)) {
        this.selectedAdmin = null;
        this.selectedGroup = null;
        this.groupsQuery = '';
        this.orderFormItems = []
      }
    },
    selectedAdmin(v) {
      if (!v) {
        this.groups = [];
        this.selectedGroup = null;
        return;
      }
      this.loadGroups();
      this.deadline.value = v.order_deadline;
    },
    selectedGroup(v) {
      if (v) this.loadOrderForms();
    },
  },
  computed: {
    computedGroups() {
      if (!this.groups) return [];

      return this.groups.map((g) => {
        return {
          value: g,
          text: g.name,
        }
      });
    },
    searchedOrderFormItems () {
      let searched = this.orderFormItems.filter((orderFormItem) => {
        let include = false;
        // search name
        include ||= orderFormItem.naziv_artikla2?.toLowerCase().includes(this.search.toLowerCase());
        // search id
        include ||= orderFormItem.id?.toString().includes(this.search.toLowerCase());

        return include;
      });

      if (this.showOrdered) {
        const headers = this.fields.filter((h) => h.key.startsWith('kol_')).map((h) => h.key)
        searched = searched.filter((item) => headers.some((key) => item[key] > 0));
      }

      return searched;
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      await axios.get('/super-admin/administrators').then(response => {
        this.admins = response.data;
      });
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  methods: {
    async loadGroups() {
      this.$store.commit('loader/START_LOADING');

      try {
        await axios.get(`/super-admin/groups/${this.selectedAdmin.id}`).then(response => {
          this.groups = response.data;
        });
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async syncPricesForAdmin() {
      if (!this.selectedAdmin) {
        return;
      }
      this.$store.commit('loader/START_LOADING');

      try {
        await axios.patch(`super-admin/pricelists/refresh/${this.selectedAdmin.id}`, {}).then(response => {
          toast('Uspešna sinhronizacija cena.', variants.SUCCESS)
        });
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async syncPrices() {
      this.$store.commit('loader/START_LOADING');

      try {
        await axios.patch(`super-admin/pricelists/refresh`, {}).then(response => {
          toast('Uspešna sinhronizacija cena.', variants.SUCCESS)
        });
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadStatuses() {
      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.get(`/super-admin/statuses`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'statusi.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje statusa.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadOrderFormSummary() {
      if (!this.selectedAdmin)
        return;

      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.get(`/super-admin/orderForms/summary/export/${this.selectedAdmin.id}`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'analiza_porudžbenica.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje analize porudžbenica.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadOrderFormItemsWithReplacement() {
      if (!this.selectedAdmin)
        return;
      if (!this.selectedGroup) 
        return;

      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.get(`/super-admin/orderForms/withGroup/export-with-replacements/${this.selectedAdmin.id}/${this.selectedGroup.id}`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'porudžbenice.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje porudžbenice.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadOrderFormItems() {
      if (!this.selectedAdmin)
        return;
      if (!this.selectedGroup) 
        return;

      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.get(`/super-admin/orderForms/withGroup/export/${this.selectedAdmin.id}/${this.selectedGroup.id}`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'porudžbenice.xlsx');
        document.body.appendChild(link);
        link.click();
        toast('Uspešno preuzimanje porudžbenice.', variants.SUCCESS)
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    refresh() {
      this.groupsQuery = '';
      this.adminQuery = '';
      this.status = '';
      this.orderFormItems = [];
      this.deadline.value = '';
    },
    async sendOrderFormExcel() {
      if (!this.selectedAdmin) {
        return;
      }

      this.$store.commit('loader/START_LOADING');

      await axios.put(`/super-admin/excelOrderedForAdmin/${this.selectedAdmin.id}`).then(() => {
        toast('Uspešno brisanje porudžbenice.', variants.SUCCESS)
        this.refresh()
      }).finally(() => this.$store.commit('loader/END_LOADING'));
    },
    async sendOrderFormPortal() {
      if (!this.selectedAdmin) {
        return;
      }

      this.$store.commit('loader/START_LOADING');

      await axios.put(`/super-admin/orderForms/${this.selectedAdmin.id}`).then(() => {
        toast('Uspešno slanje porudžbenice.', variants.SUCCESS)
        this.refresh()
      }).finally(() => this.$store.commit('loader/END_LOADING'));
    },
    async sendAggregateOrderFormPortal() {
      if (!this.selectedAdmin) {
        return;
      }

      this.$store.commit('loader/START_LOADING');

      await axios.put(`/super-admin/orderForms/aggregate/${this.selectedAdmin.id}`).then(() => {
        toast('Uspešno slanje zbirne porudžbenice.', variants.SUCCESS)
        this.refresh()
      }).finally(() => this.$store.commit('loader/END_LOADING'));
    },
    async sendAggregateByGroupOrderFormPortal() {
      if (!this.selectedAdmin) {
        return;
      }

      this.$store.commit('loader/START_LOADING');

      await axios.put(`/super-admin/orderForms/aggregate-by-groups/${this.selectedAdmin.id}`).then(() => {
        toast('Uspešno slanje zbirne porudžbenice po grupama.', variants.SUCCESS)
        this.refresh()
      }).finally(() => this.$store.commit('loader/END_LOADING'));
    },
    async setStatus(status) {
      if (!this.selectedAdmin) {
        return;
      }
      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.put(`/super-admin/administrators/setStatus/${this.selectedAdmin.id}`, { status: status });

        if (response.status == 200) {
          toast('Uspešno promenjen status.', variants.SUCCESS)
          this.status = status;
        }

      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async sendReminder() {
      if (!this.selectedAdmin) {
        return;
      }
      this.$store.commit('loader/START_LOADING');
      try {
        const response = await axios.get(`/super-admin/employees/getForAdmin/${this.selectedAdmin.id}`);
        const email = this.selectedAdmin.user.email;
        const bccList = response.data.map(employee => employee.user.email).join(',');
        const subject = 'Podsetnik za popunjavanje porudžbenice';
        const body = '';
        const mailtoLink = `mailto:${email}?bcc=${bccList}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
        toast('Uspešno otvoren šablon podsetnika.', variants.SUCCESS)
      } catch (e) {
         // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async setDeadline() {
      if (!this.selectedAdmin) {
        return;
      }

      if (!this.deadline.value || new Date(this.deadline.value) < new Date()) {
        this.deadline.error = true;
        this.deadline.errorMessage = 'Krajnji rok ne može biti u prošlosti.';
        return;
      }
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.put(`/super-admin/administrators/${this.selectedAdmin.id}/order-deadline`, { order_deadline: this.deadline.value }).then(() => {
          toast('Uspešno izmenjen krajnji rok za firmu ' + this.selectedAdmin.company_name + '.', variants.SUCCESS)
          this.selectedAdmin.order_deadline = this.deadline.value;
        });
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async loadOrderForms() {
      if (!this.selectedAdmin)
        return;
      if (!this.selectedGroup) {
        return;
      }

      this.$store.commit('loader/START_LOADING');

      axios.get(`/super-admin/orderForms/withGroup/${this.selectedAdmin.id}/${this.selectedGroup.id}`).then(response => {
        if (response.data.order_forms.length == 0) {
          this.orderFormItems = [];
          return;
        }

        this.orderFormItems = [...response.data.order_forms[0].items];
        const headers = [];
        for (const orderForm of response.data.order_forms) {
          const key = 'kol_' + orderForm.id;
          for (const item of orderForm.items) {
            const found = this.orderFormItems.find(i => i.id === item.id);
            if (found) {
              found[key] = item.kol;
            }
          }
          headers.push({
              key, 
              label: orderForm.object_name,
              sortable: false,
              showTooltip: !!orderForm.employee_note,
              tooltipText: `${orderForm.employee_note}` 
          });
        }
        if (response.data.order_forms.length > 0) {
          this.status = response.data.order_forms[0].status;
        }
        this.fields = [...this.initialFields, ...headers];
      }).finally(() => this.$store.commit('loader/END_LOADING'));
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="row mb-2">
      <div class="col-12 col-md-4 d-flex">
        <label class="col-form-label mr-2" for="admins">Firma:</label>
        <VueBootstrapAutocomplete
          class="autocomplete"
          id="admins"
          :data="admins"
          :serializer="(item) => item.company_name"
          :minMatchingChars="0"
          showOnFocus
          v-model="adminQuery"
          @hit="selectedAdmin = $event"
        />
      </div>
      
      <div class="col-12 col-md-8 d-flex justify-content-end">
        <b-button  variant="secondary" @click="loadOrderForms()" :disabled="!this.selectedAdmin || !this.selectedGroup">
          Osveži
          <i class="mdi mdi-refresh"></i>
        </b-button>
        <b-button  class="ml-2" variant="secondary" @click="sendReminder()" :disabled="!this.selectedAdmin">
          Pošalji podsetnik
          <i class="fas fa-calendar ml-1"></i>
        </b-button>
        <confirmation-modal 
          variant="secondary"
          message="Da li ste sigurni da želite da sinhronizujete cene.
            Ova opcija menja cene kod svih kupaca uključujući i porudžbine koje su u toku"
          title="Sinhronizovanje cena"
          buttonText="Sinhronizuj cene"
          @onSubmit="syncPrices" 
        />
        <confirmation-modal 
          :disabled="!this.selectedAdmin"
          variant="secondary"
          :message="`Da li ste sigurni da želite da sinhronizujete cene za firmu: ${!this.selectedAdmin ? '' : this.selectedAdmin.company_name}.
            Ova opcija menja cene kod izabranog kupca ukljčujući i porudžbinu u toku.`"
          title="Sinhronizovanje cena za firmu"
          buttonText="Sinhronizuj cene za firmu"
          @onSubmit="syncPricesForAdmin" 
          buttonClass="mr-2"/>
        <b-dropdown  right variant="primary">
          <template slot="button-content">
            <i class="fas fa-file-download mr-1"></i>
              Preuzmi
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item :disabled="!this.selectedAdmin || !this.selectedGroup" @click="downloadOrderFormItems()">Porudžbenice - Excel</b-dropdown-item>
          <b-dropdown-item :disabled="!this.selectedAdmin || !this.selectedGroup" @click="downloadOrderFormItemsWithReplacement()">Porudžbenice (Zamenski artikli) - Excel</b-dropdown-item>
          <b-dropdown-item :disabled="!this.selectedAdmin" @click="downloadOrderFormSummary()">Analiza porudžbenica - Excel</b-dropdown-item>
          <b-dropdown-item @click="downloadStatuses()">Statusi firma</b-dropdown-item>
        </b-dropdown>
      </div>
      
    </div>
    <div class="row mb-2">
      <div class="col-12 col-md-4 d-flex">
        <label class="col-form-label mr-2" for="groups">Grupa:</label>
        <b-form-select id="groups" v-model="selectedGroup" :options="computedGroups">
          <template #first>
            <b-form-select-option :value="null" disabled>-- Izaberi grupu --</b-form-select-option>
          </template>
        </b-form-select>
        <!-- <VueBootstrapAutocomplete
          class="autocomplete"
          id="groups"
          v-model="groupsQuery"
          :data="groups"
          :serializer="(item) => item.name"
          :minMatchingChars="0"
          showOnFocus
          @hit="selectedGroup = $event"
        /> -->
      </div>

      <div class="col-12 col-lg-8 d-flex justify-content-end">
        <b-dropdown :disabled="!selectedAdmin" right :variant="this.status === 'ALLOW_ORDERING' ? 'success': 'danger'">
          <template slot="button-content">
              Status: <span style="text-transform: capitalize">{{ this.statuses.find(s => s.key == this.status) ?  this.statuses.find(s => s.key == this.status).value: '' }}</span>
          </template>
          <b-dropdown-item-button  v-for="s of statuses" v-bind:key="s.key" @click="setStatus(s.key)">{{ s.value }}</b-dropdown-item-button>
        </b-dropdown>
        <confirmation-modal 
          :disabled="!selectedAdmin"
          variant="success"
          message="Da li ste sigurni da želite da bespovratno obrišete
            porudžbenicu sa ovog sistema? Zbog sigurnosti prethodno je snimite tasterom 'Preuzmi'!"
          title="Brisanje porudžbenice"
          buttonText="Brisanje porudžbenice"
          @onSubmit="sendOrderFormExcel" />
        <confirmation-modal 
          :disabled="!selectedAdmin"
          variant="success"
          message="Da li ste sigurni da želite da pošaljete porudžbenicu u APP?"
          title="Pošalji porudžbenicu u APP"
          buttonText="Pošalji porudžbenicu u APP"
          @onSubmit="sendOrderFormPortal" />
        <confirmation-modal 
          :disabled="!selectedAdmin"
          variant="success"
          message="Da li ste sigurni da želite da pošaljete zbirnu porudžbenicu u APP?"
          title="Pošalji zbirnu porudžbenicu u APP"
          buttonText="Pošalji zbirnu porudžbenicu u APP"
          @onSubmit="sendAggregateOrderFormPortal" />
      </div>
    </div>
    <div class="row mb-2 mt-2">
      <div class="col-sm-6 col-12 d-flex align-items-center">
        <label class="col-form-label mr-2" for="input-1">Krajnji rok:</label>
          <b-form-input
          id="input-1"
          v-model="deadline.value"
          @input="deadline.error = false"
          type="date"
          required
          style="width: 200px"
          :class="{ 'is-invalid': deadline.error , 'ml-2': true}"
        ></b-form-input>
          <button class="btn btn-primary ml-2" @click="setDeadline()" :disabled="!this.selectedAdmin">Snimi</button>
          <b-form-invalid-feedback v-if="deadline.error"
          class="ml-2"
            style="width: 200px"
          >
            {{deadline.errorMessage}}
          </b-form-invalid-feedback>
      </div>
      <div class="col-sm-6 col-12 align-items-center justify-content-end d-flex">
        <confirmation-modal 
          :disabled="!selectedAdmin"
          variant="success"
          buttonClass="mr-5"
          message="Da li ste sigurni da želite da pošaljete zbirnu porudžbenicu po grupama u APP?"
          title="Pošalji zbirnu porudžbenicu po grupama u APP"
          buttonText="Pošalji zbirnu porudžbenicu po grupama u APP"
          @onSubmit="sendAggregateByGroupOrderFormPortal" />
        <b-form-checkbox
          v-model="showOrdered"
          :value="true"
          :unchecked-value="false"
          switch
        >
          Prikaži samo poručene artikle
        </b-form-checkbox>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12">
        <div class="search-box chat-search-box ">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Pretraži..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-table :items="searchedOrderFormItems" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
        >
          <template v-for="field in fields" v-slot:[`head(${field.key})`]>
            <span :key="`tooltip-${field.key}`" v-if="field.key.startsWith('kol_') && field.showTooltip" class="d-flex align-items-center">
              {{ field.label }}
              <i 
                class="fas fa-info-circle ml-1" 
                v-b-tooltip.hover.right 
                :title="field.tooltipText"
              ></i>
            </span>
            <span :key="`regular-${field.key}`" v-else-if="field.key.startsWith('kol_')">
              {{ field.label }}
            </span>
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
  .autocomplete {
    width: 100%;
  }  
  .fa-info-circle {
    opacity: 0.8;
  }
  .fa-info-circle:hover {
    opacity: 1;
  }
</style>
